import { useState, useCallback } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface KeywordsState {
  keywords: string[];
  isLoading: boolean;
  error: string | null;
}

export const useKeywords = () => {
  const [keywordsState, setKeywordsState] = useState<KeywordsState>({
    keywords: [],
    isLoading: false,
    error: null,
  });

  const { fetchWithAuth } = useFetch();

  const fetchKeywords = useCallback(async (): Promise<void> => {
    setKeywordsState(prev => ({
      ...prev,
      isLoading: true,
      error: null,
    }));

    try {
      // A rota /materials/keywords não requer autenticação, mas vamos usar fetchWithAuth para manter consistência
      const response = await fetch(`${API_CONFIG.BASE_URL}/materials/keywords`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao buscar keywords: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      const keywords = data.keywords || [];

      setKeywordsState(prev => ({
        ...prev,
        keywords,
        isLoading: false,
      }));
    } catch (error) {
      setKeywordsState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
      }));
    }
  }, []);

  return {
    keywords: keywordsState.keywords,
    isLoading: keywordsState.isLoading,
    error: keywordsState.error,
    fetchKeywords,
  };
};

